import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Presentation shell for Collateral Support Program (CSP) application details.
 * Branch CSP-specific layout/fields here as the refactor continues.
 */
export function CspApplicationDetailsForm({ children, className = '' }: Props) {
  return (
    <div
      className={`application-details-form application-details-form--csp ${className}`.trim()}
      data-application-details-program="csp"
    >
      {children}
    </div>
  );
}

export default CspApplicationDetailsForm;
